/**
 * Created by gwi on 2017/1/20.
 */
import {get} from './base.service'
export default{
    getPayChannels(params) {
        return get('/app/pay/channels/{busiType}', {params: params});
    },
    //获取当前界面URL及指定参数内容
    getUrlParams(name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        var r = window.location.search.substr(1).match(reg); //获取url中"?"符后的字符串并正则匹配
        var context = "";
        if (r != null) {
            context = r[2];
        }
        // else {
        //     reg = null;
        //     r = null;
        // }
        return context == null || context === "" || context === "undefined" ? "" : context;
    },
    //1.获取医院appId、appSecret
    getHosAppId() {
        var params = {
            channelId:'4',
            invokeType:'2'
        }
        return get('/app/pay/config/{channelId}/{invokeType}', {
            params: params
        });
    },
    //2.获取微信返回用户code
    getUserCode(params) {
        // var redirect_uri = REDIRECT_URL +BASE_URL;
        var redirect_uri = REDIRECT_URL;
        if ('TFY' === localStorage.channel) {
            // redirect_uri = 'https://pzwjw-imts.hngwmt.com/pay' + BASE_URL;
            redirect_uri = location.origin + PUBLIC_PATH + "pay";
        }
        var codeUrl = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid='+params.appId+'&redirect_uri='+redirect_uri+'&response_type=code&scope=snsapi_base&state=STATE&connect_redirect=1#wechat_redirect'
        window.open(codeUrl)
    },
    //3.获取微信返回用户openId
    getOpenId(params) {
        var openIdUrl = '/access_token?appid='+params.appId+'&secret='+params.appSecret+'&code='+params.code+'&grant_type=authorization_code';
        return get(openIdUrl).then(res => {
            return res;
        });
    },
    //4.获取后台返回payInfo
    getPayInfo() {

    },
    //5.拉起微信支付
    goWechatPay() {

    }
}



// WEBPACK FOOTER //
// ./src/service/pay.service.js